import { Template } from "../template"
import { Point } from "./point"

let FLAG = 0
const FLAGS = [
  {
    title: "Colombia",
    dots: 5,
    colors: [
      { size: 2 / 4, color: "#fdd116" },
      { size: 1 / 4, color: "#013893" },
      { size: 1 / 4, color: "#ce1127" },

    ],
  },
  
]

class Flag extends Template {
  constructor() {
    const args = [
      "\n%c %c %c %c %cby @andrevenancio%cexclusive for hicetnunc.xyz\n",
      "background: #fdd116; padding: 4px;",
      "background: #fdd116; padding: 4px;",
      "background: #013893; padding: 4px;",
      "background: #ce1127; padding: 4px;",
      "background: #000000; color: #00ffff; font-size: x-small;padding: 4px;",
      "background: transparent; color: #999999; font-size: x-small;padding: 4px;",
    ]

    super({ ratio: 1, args })
  }

  setup() {
   
    const canvas = document.createElement("canvas")
    document.body.appendChild(canvas)

    this.context = canvas.getContext("2d")

    // 6th May 2021
    this.friction = 0.95
    this.spring = 0.04
  }

  buildFlag() {
    this.dots = FLAGS[FLAG % FLAGS.length].dots
    this.minDist = this.width / this.dots - 1

    this.points = []

    // stripes
    let y = 0
    const f = FLAG % FLAGS.length
    for (let c = 0; c < FLAGS[f].colors.length; c++) {
      const height = this.height * FLAGS[f].colors[c].size
      const color = FLAGS[f].colors[c].color

      // dots
      for (let i = 0; i < this.dots; i++) {
        const x = (this.width / (this.dots - 2)) * i
        const p = new Point(x, y, height, color)
        this.points.push(p)
      }

      y += height
    }
  }

  resize(width, height, ratio) {
    this.context.canvas.width = width * ratio
    this.context.canvas.height = height * ratio
    this.context.canvas.style.width = `${width}px`
    this.context.canvas.style.height = `${height}px`

    this.buildFlag()
  }

  update() {
    this.context.clearRect(
      0,
      0,
      this.context.canvas.width,
      this.context.canvas.height
    )

    // move dots
    for (let i = 0; i < this.points.length; i++) {
      this.points[i].vy +=
        (this.points[i].restY - this.points[i].y) * this.spring

      if (this.mouse.down) {
        const dx = this.mouse.x - this.points[i].x
        const dy = this.mouse.y - this.points[i].restY
        const dist = Math.sqrt(dx * dx + (dy / 2) * (dy / 2))
        // const dist = Math.sqrt(dx * dx + dy * dy)
        if (dist < this.minDist) {
          this.points[i].vy += (this.mouse.y - this.points[i].y) * this.spring
        }
      }

      this.points[i].vy *= this.friction
      this.points[i].y += this.points[i].vy
    }

    // draw
    for (let i = 0; i < this.points.length; i += this.dots) {
      this.context.beginPath()
      this.context.fillStyle = this.points[i].color
      this.context.moveTo(this.points[i + 0].x, this.points[i + 0].y)
      for (let j = 0; j < this.dots - 1; j++) {
        const cx = (this.points[i + j].x + this.points[i + j + 1].x) * 0.5
        const cy = (this.points[i + j].y + this.points[i + j + 1].y) * 0.5
        this.context.quadraticCurveTo(
          this.points[i + j].x,
          this.points[i + j].y,
          cx,
          cy
        )
      }
      this.context.lineTo(this.width, this.height)
      this.context.lineTo(0, this.height)
      this.context.lineTo(0, this.points[0].y)
      this.context.fill()
    }
  }
}

const app = new Flag()
